import { memo, useState } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Col, Form, Row } from 'react-bootstrap';
import CreateBtn from '../createBtn';
import { FaSearch } from 'react-icons/fa';
import { InputGroup, FormControl } from 'react-bootstrap';

const PediatricHistory = ({ selectedData, setSelectedHistories }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [typeaheadRef, setTypeaheadRef] = useState(null);

    // this function will handle the search query and fetch the options from the server
    const handleSearch = (query) => {
        setIsLoading(true);
        setTimeout(() => {
            const fruits = ['Apple', 'Banana', 'Cherry', 'Durian', 'Elderberry'];
            const filtered = fruits
                .filter((fruit) => fruit.toLowerCase().includes(query.toLowerCase()))
                .map((name) => ({ name }));
            setOptions(filtered);
            setIsLoading(false);
        }, 500);
    };

    const updatePediatricData = (fieldName, val) => {
        if (!selectedData['pediatric']) {
            selectedData['pediatric'] = {};
        }

        selectedData['pediatric'][fieldName] = val;
        setSelectedHistories({ ...selectedData });
    };


    const handleBirthHistorySelect = (selected) => {
        if (selected && selected.length > 0) {
            const currentBirthHistory = selectedData?.pediatric?.birthHistory || [];

            const birthHistoryArray = Array.isArray(currentBirthHistory)
                ? [...currentBirthHistory]
                : currentBirthHistory ? [currentBirthHistory] : [];

            if (!birthHistoryArray.includes(selected[0].name)) {
                birthHistoryArray.push(selected[0].name);
                updatePediatricData('birthHistory', birthHistoryArray);
            }

            if (typeaheadRef) {
                typeaheadRef.clear();
            }
        }
    };

    return (
        <div className="p-3">
            {/* Birth History */}
            <Form.Group as={Row} className="mb-3 mt-2 common-font-size align-items-center">
                <Form.Label column sm={2} htmlFor="birth-history-typeahead">
                    Birth History:
                </Form.Label>
                <Col sm={7} >
                    <AsyncTypeahead
                        id="birth-history-typeahead"
                        labelKey="name"
                        isLoading={isLoading}
                        onSearch={handleSearch}
                        options={options}
                        placeholder="Search/Add birth history.."
                        minLength={2}
                        size="sm"
                        onChange={handleBirthHistorySelect}
                        ref={(ref) => setTypeaheadRef(ref)}
                    />
                </Col>
                <Col sm={3}>
                    <Form.Control
                        as="textarea"
                        placeholder="Note"
                        value={selectedData?.pediatric?.birthNote || ''}
                        onChange={(e) => updatePediatricData('birthNote', e.target.value)}
                        size="sm"
                    />
                </Col>
            </Form.Group>


            <Form.Group as={Row} className="mb-3 align-items-center">
                <Form.Label column sm={2}>
                    Immunization History:
                </Form.Label>
                <Col sm={5}>
                    <Form.Check
                        inline
                        type="radio"
                        label="Complete"
                        name="immunizationStatus"
                        id="immunization-complete"
                        value="complete"
                        checked={selectedData?.pediatric?.immunizationStatus === 'complete'}
                        onClick={() => { updatePediatricData('immunizationStatus', selectedData?.pediatric?.immunizationStatus === 'complete' ? '' : 'complete')
                        }}
                    />
                    <Form.Check
                        inline
                        type="radio"
                        label="Incomplete"
                        name="immunizationStatus"
                        id="immunization-incomplete"
                        value="incomplete"
                        checked={selectedData?.pediatric?.immunizationStatus === 'incomplete'}
                        onClick={() => {
                            updatePediatricData('immunizationStatus', selectedData?.pediatric?.immunizationStatus === 'incomplete' ? '' : 'incomplete')
                        }}
                    />
                </Col>
                <Col sm={5}>
                    <Form.Control
                        as="textarea"
                        className="form-control-sm"
                        placeholder="Note"
                        value={selectedData?.pediatric?.immunizationNote || ''}
                        onChange={(e) => updatePediatricData('immunizationNote', e.target.value)}
                        size="sm"
                    />
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm={2}>
                    Past Illness:
                </Form.Label>
                <Col sm={10}>
                    <Form.Control
                        as="textarea"
                        placeholder="Note"
                        value={selectedData?.pediatric?.pastIllnessNote || ''}
                        onChange={(e) => updatePediatricData('pastIllnessNote', e.target.value)}
                        size="sm"
                    />
                </Col>
            </Form.Group>


            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm={2}>
                    Development History:
                </Form.Label>
                <Col sm={10}>
                    <Form.Control
                        as="textarea"
                        placeholder="Note"
                        value={selectedData?.pediatric?.developmentNote || ''}
                        onChange={(e) => updatePediatricData('developmentNote', e.target.value)}
                        size="sm"
                    />
                </Col>
            </Form.Group>


            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm={2}>
                    Physical/ Neurological Findings:
                </Form.Label>
                <Col sm={10}>
                    <Form.Control
                        as="textarea"
                        placeholder="Note"
                        value={selectedData?.pediatric?.physicalNote || ''}
                        onChange={(e) => updatePediatricData('physicalNote', e.target.value)}
                        size="sm"
                    />
                </Col>
            </Form.Group>
        </div>
    );
};

export default memo(PediatricHistory);